import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from '../components/layout';
import SEO from '../components/seo';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Layout tag="styleguides" mdxType="Layout">
      <SEO title="Design Systems & Style Guides" mdxType="SEO" />
      <h1>{`Design Systems & Style Guides`}</h1>
      <h2>{`USWDS`}</h2>
      <p>{`The U.S. Web Design System(USWDS) is a design system for the federal government. Its goal is to make it easier to build accessible, mobile-friendly government websites for the American public.`}</p>
      <p>{`It has been made a more important tool with the `}<a parentName="p" {...{
          "href": "https://digital.gov/resources/21st-century-integrated-digital-experience-act/"
        }}>{`21st Century Integrated Digital Experience Act(IDEA)`}</a>{` which states that it should be used for federal government websites.`}</p>
      <p>{`The Drupal 8 theme for USWDS is maintained be fellow CivicACtioners Iris Ibekwe and Jay Darnell.`}</p>
      <h3>{`USWDS Resources:`}</h3>
      <ul>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://designsystem.digital.gov/"
          }}>{`USWDS home`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://chat.18f.gov/"
          }}>{`USWDS Slack`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://www.drupal.org/project/uswds"
          }}>{`USWDS Drupal 8 theme`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://www.youtube.com/watch?v=cXy88gKfv9I"
          }}>{`USWDS Prototyping presentation`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://www.youtube.com/watch?v=NyeztZjc4lI"
          }}>{`Getting started with Drupal/USWDS presentation`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://youtu.be/-mWm-2V-DLA"
          }}>{`Drupal multiple USWDS sub-theme presentation`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://brianseek.github.io/uswds-color-picker/"
          }}>{`USWDS Color Compare tool`}</a></li>
      </ul>
      <h2>{`Patern Lab`}</h2>
      <p>{`Pattern Lab is a frontend workshop environment that helps you build, view, test, and showcase your design system's UI components.`}</p>
      <h3>{`Pattern Lab Resources:`}</h3>
      <ul>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://patternlab.io/"
          }}>{`Pattern Lab Home`}</a></li>
      </ul>
    </Layout>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      